import React from 'react';
import PropTypes from 'prop-types';
import Messages from './Messages';
import eventOptionsFactory from '../../../events/options-factory';
import cx from 'classnames';
import './FlashMessages.scss';

const invalidatingEvents = ['scroll', 'wheel', 'resize'];

const eventOptions = eventOptionsFactory({
  passive: true,
});

class FlashMessages extends React.Component {
  static propTypes = {
    notices: PropTypes.arrayOf(PropTypes.string).isRequired,
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  state = {
    isFixed: false,
    offset: null,
  };

  constructor(props) {
    super(props);
    this.requestRedraw = this.requestRedraw.bind(this);
    this.redraw = this.redraw.bind(this);
    this.onRef = this.onRef.bind(this);
  }

  componentDidMount() {
    this._prevPosition = -1;
    this._prevOffset = -1;
    invalidatingEvents.forEach(eventName => {
      document.addEventListener(eventName, this.requestRedraw, eventOptions);
      window.addEventListener(eventName, this.requestRedraw, eventOptions);
    });
    this.requestRedraw();
  }

  componentWillUnmount() {
    invalidatingEvents.forEach(eventName => {
      document.removeEventListener(eventName, this.requestRedraw, eventOptions);
      window.removeEventListener(eventName, this.requestRedraw, eventOptions);
    });

    this._raf = false;
    cancelAnimationFrame(this._rafId);

    this._$flashMessage = null;
  }

  requestRedraw() {
    if (!this._raf) {
      this._raf = true;
      this._rafId = requestAnimationFrame(this.redraw);
    }
  }

  redraw() {
    if (!this._raf) {
      return;
    }
    this._raf = false;

    if (this._$flashMessage) {

      const currentOffset = this._$flashMessage.getBoundingClientRect().top;
      const currentPosition = window.pageYOffset;

      const positionChanged = this._prevPosition !== currentPosition || this._prevOffset !== currentOffset;
      const isFixed = currentPosition > 0;

      const headerSelector = '.header-wrap header';
      const header = document.querySelector(headerSelector);
      const isMainHeader = Array.from(header.parentNode.classList).includes('main-header');
      let offset = null;

      if (isFixed) {
        if (isMainHeader) {
          offset = 65;
        } else {
          offset = header.getBoundingClientRect().height;
        }
      }

      if (positionChanged) {
        this.setState({ offset }, () => {
          if (this.state.isFixed !== isFixed) {
            this.setState({ isFixed });
          }
        });
      }

      this._prevOffset = currentOffset;
      this._prevPosition = currentPosition;
    }
  }

  onRef($el) {
    if (this._$flashMessage !== $el) {
      this._$flashMessage = $el;
      this.requestRedraw();
    }
  }

  render() {
    const props = this.props;
    const { isFixed, offset } = this.state;

    return (
      <div
        className={cx('flash-messages', { 'flash-messages--fixed': isFixed })}
        ref={this.onRef}
        style={{ top: isFixed && offset }}>
        <Messages messageType="notice" messages={props.notices}/>
        <Messages messageType="error" messages={props.errors}/>
      </div>
    );
  }
}

export default FlashMessages;



// WEBPACK FOOTER //
// ./src/client/js/view/components/FlashMessages/FlashMessages.js